import React from 'react';
import { StyleProp, TextStyle, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';

interface Props {
    label: string;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
}

export default function OseFieldLabel({ label, required = false, labelStyle }: Props) {
    const { styles } = useStyles(styleSheet);

    return (
        <View style={styles.row}>
            <MyAppText style={labelStyle}>{label}</MyAppText>
            {required && (
                <MyAppText style={[labelStyle, styles.asterisk]}>(*)</MyAppText>
            )}
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: 5,
    },
    asterisk: {
        color: theme.colors.errors['300'],
        fontWeight: '400',
    },
}));
